import { useEffect, useState } from "react";

// Replaces <sdx-header>: that SDX web component bakes the Swisscom "lifeform"
// logo into its shadow DOM (fixed background-image, no logo slot/attribute),
// so it can't be rebranded in place. This mirrors its layout (72px bar,
// left-aligned home logo) with the GreenOne logo instead.
//
// The inner wrapper mirrors GreenOneDashboardV2's content column (maxWidth
// 1440, same responsive padding) so the logo lines up with the dashboard
// content below it instead of sitting flush against the viewport edge.
export default function AppHeader({ onLoginClick, onRegisterClick }) {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1440
  );
  const [heroVisible, setHeroVisible] = useState(true);

  useEffect(() => {
    function onResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Buttons only apply on the landing page, which passes both handlers and
  // renders a #hero-section element to observe.
  const showAuthButtons = !!onLoginClick && !!onRegisterClick;

  useEffect(() => {
    if (!showAuthButtons) return;

    const heroEl = document.getElementById("hero-section");
    if (!heroEl) return;

    const observer = new IntersectionObserver(
      ([entry]) => setHeroVisible(entry.isIntersecting),
      { threshold: 0 }
    );
    observer.observe(heroEl);
    return () => observer.disconnect();
  }, [showAuthButtons]);

  const isMobile = windowWidth < 700;
  const isTablet = windowWidth < 1100;
  const contentPadding = isMobile ? "1rem" : isTablet ? "1.5rem" : "2rem";

  return (
    <header
      data-app-header
      style={{
        height: "72px",
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #ddd",
        position: "sticky",
        top: 0,
        zIndex: 100,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          height: "100%",
          maxWidth: 1440,
          margin: "0 auto",
          padding: `0 ${contentPadding}`,
          display: "flex",
          alignItems: "center",
          boxSizing: "border-box",
        }}
      >
        <a
          href="/"
          aria-label="GreenOne Home"
          style={{ display: "flex", alignItems: "center", height: "32px" }}
        >
          <img
            src="/logos/greenone-header.svg"
            alt="GreenOne"
            style={{ height: "100%", width: "auto" }}
          />
        </a>

        {showAuthButtons && (
          <div
            style={{
              marginLeft: "auto",
              display: "flex",
              alignItems: "center",
              gap: "0.75rem",
              opacity: heroVisible ? 0 : 1,
              pointerEvents: heroVisible ? "none" : "auto",
              transition: "opacity 0.2s ease",
            }}
          >
            <button
              type="button"
              className="hero-btn"
              style={{
                backgroundColor: "transparent",
                color: "#026F6D",
                border: "1.5px solid #026F6D",
              }}
              onClick={onLoginClick}
            >
              Login
            </button>
            <button
              type="button"
              className="hero-btn hero-btn-primary"
              onClick={onRegisterClick}
            >
              Kostenlos testen
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
